import { Suspense, lazy } from "react";
import Loader from "./common/Loader"; // We need to verify where Loader is or create a simple fallback
import Home from "./components/layout/Home"; // Keep Home eager for LCP
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import {
  Route,
  Routes,
  useLocation,
  Link,
  BrowserRouter,
} from "react-router-dom";
import { useEffect } from "react";
import ParticlesBackground from "./components/animations/BackgroundFX";
import ScrollToTopButton from "./common/ScrollToTopButton";
import Lenis from 'lenis';

function useSecurity() {
  useEffect(() => {
    // Only apply in production
    if (process.env.NODE_ENV === "development") return;

    // Disable right-click
    const handleContextMenu = (e) => {
      e.preventDefault();
    };

    // Disable devtools shortcuts
    const handleKeyDown = (e) => {
      // F12
      if (e.keyCode === 123) {
        e.preventDefault();
      }
      // Ctrl + Shift + I/J/C
      if (e.ctrlKey && e.shiftKey && (e.keyCode === 73 || e.keyCode === 74 || e.keyCode === 67)) {
        e.preventDefault();
      }
      // Ctrl + U (View Source)
      if (e.ctrlKey && e.keyCode === 85) {
        e.preventDefault();
      }
    };

    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);

    // Actively discourage debugger usage
    const devToolsCheck = setInterval(() => {
      (function () {
        return false;
      })
        ["constructor"]("debugger")
        ["call"]();
    }, 500);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
      clearInterval(devToolsCheck);
    };
  }, []);
}

// Lazy load other pages
const AboutPage = lazy(() => import("./components/pages/AboutPage"));
const ProcessPage = lazy(() => import("./components/pages/ProcessPage"));
const ProductsPage = lazy(() => import("./components/pages/ProductsPage"));
const ProjectsPage = lazy(() => import("./components/pages/ProjectsPage"));
const Contact = lazy(() => import("./components/pages/Contact"));
const LegalPage = lazy(() => import("./components/pages/LegalPage"));

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}

function Shell() {
  const { hash, pathname } = useLocation();
  useEffect(() => {
    if (!hash) return;
    const el = document.querySelector(hash);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }, [hash, pathname]);

  return (
    <div className="min-h-screen relative">
      <ParticlesBackground />
      <Header />
      <main className="pt-16">
        <Suspense fallback={<Loader fullScreen />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/process" element={<ProcessPage />} />
            <Route path="/products" element={<ProductsPage />} />
            <Route path="/projects" element={<ProjectsPage />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<LegalPage />} />
            <Route path="/terms-of-service" element={<LegalPage />} />
            <Route path="/services" element={<LegalPage />} />
            <Route
              path="*"
              element={
                <div className="max-w-4xl mx-auto px-4 py-24">
                  <h1 className="text-3xl font-bold">Page not found</h1>
                  <p className="text-white/70 mt-3">
                    Try going{" "}
                    <Link to="/" className="underline">
                      home
                    </Link>
                    .
                  </p>
                </div>
              }
            />
          </Routes>
        </Suspense>
        <Footer />
      </main>
    </div>
  );
}

export default function App() {
  const { pathname } = useLocation();
  useSecurity();

  useEffect(() => {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      wrapper: window,
      content: document.documentElement,
      lerp: 0.1,
      smoothWheel: true,
    });

    function raf(time) {
      lenis.raf(time);
      requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    // Auto-resize Lenis when content changes height
    const resizeObserver = new ResizeObserver(() => {
      lenis.resize();
    });
    resizeObserver.observe(document.body);

    return () => {
      lenis.destroy();
      resizeObserver.disconnect();
    };
  }, []);

  // Ensure scroll top on route change (already handled by ScrollToTop, but let's be extra safe)
  return (
    <>
      <ScrollToTop />
      <Shell />
      <ScrollToTopButton />
    </>
  );
}
